<script setup lang="ts">
import TransportsWrapper from '@/components/transports/TransportsWrapper.vue';
import { RoleGroups } from '@/constants/Roles';
import { TransportType } from '@/constants/TransportType';

definePage({
  name: 'TransportsOther',
  meta: {
    title: 'pageTitles.otherTransports',
    roles: RoleGroups.Transports
  }
});
</script>

<template>
  <TransportsWrapper :transport-type="TransportType.Other" />
</template>

<style scoped>

</style>